import { Documents} from '../services/api'

export const checkFile = (data: any) => {
    return (dispatch: any) => {
        return dispatch({type: 'FILES_CHECK', ...data})
    }
};

export const resetFile = (data: any) => {
    return (dispatch: any) => {
        return  dispatch({type: 'FILES_RESET', ...data})
    }
};

export const resetUploads = () => {
    return (dispatch: any) => {
        return  dispatch({type: 'FILES_RESET_ALL'})
    }
};

export const uploadFile = (data: any) => {
    return async (dispatch: any) => {
        try {
            dispatch({type: 'FILE_LOADING', payload: true});

            const payload = await Documents.uploadFile(data);
            dispatch({type: 'FILE_UPLOAD', payload});

            return dispatch({type: 'FILE_LOADING', payload: false})
        } catch (e) {
            dispatch({type: 'FILE_UPLOAD_ERROR', payload: e});
            return dispatch({type: 'FILE_LOADING', payload: false})
        }
    }
};

export const deleteFile = (data: any) => {
    return async (dispatch: any) => {
            const payload = await Documents.deleteFile(data);
            return dispatch({type: 'FILE_DELETE', payload})
    }
};

export const setDefaultFiles = (data: any) => {
    return (dispatch: any) => {
        return  dispatch({type: 'FILES_DEFAULT', payload: data})
    }
};
